import { Component, OnDestroy } from '@angular/core';
import { SessionService } from '../../../core/state/session/session.service';
import { SessionQuery } from '../../../core/state/session/session.query';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { mapTo, startWith, takeUntil, tap } from 'rxjs/operators';
import { BehaviorSubject, merge, Observable, Subject } from 'rxjs';
import { RouterQuery } from '@datorama/akita-ng-router-store';
import { filterNilValue } from '@datorama/akita';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnDestroy {
    unsubscribe$ = new Subject();
    loginForm: UntypedFormGroup = this._fb.group({
        username: ['', [Validators.required]],
        password: ['', [Validators.required]]
    });
    submit$ = new Subject();
    isSubmitted$: Observable<boolean> = merge(
        this.loginForm.valueChanges.pipe(mapTo(false), startWith(false)),
        this.submit$.pipe(mapTo(true))
    ).pipe(tap((_) => this.error$.next(false)));

    error$ = new Subject();
    isLoading$ = new BehaviorSubject(false);
    state$ = this.sessionQuery.loadingState$;

    constructor(
        private _fb: UntypedFormBuilder,
        private session: SessionService,
        private sessionQuery: SessionQuery,
        public user: SessionQuery,
        private router: Router,
        private _routerQuery: RouterQuery
    ) {}

    reason$ = this._routerQuery.selectQueryParams('reason').pipe(
        filterNilValue(),
        tap((_) => {
            // clear reason query param so that it doesn't show up again if page is refreshed
            this.router.navigate([], { queryParams: { reason: null } });
        })
    );
    login() {
        // emit submit subject
        this.submit$.next(true);

        // form is valid...
        if (this.loginForm.valid) {
            this.isLoading$.next(true);
            this.loginForm.value.username = this.loginForm.value.username.toLowerCase();
            this.session
                .login(this.loginForm.value)
                .pipe(
                    tap((_) => this.isLoading$.next(false)),
                    takeUntil(this.unsubscribe$)
                )
                .subscribe(null, (error) => {
                    if (error.twoFactorRequired) {
                        this.router.navigate([
                            'two-factor',
                            error.twoFactorRequired.primary
                        ]);
                    }
                    // reset password input
                    this.loginForm.controls['password'].reset();
                    this.submit$.next(false);
                    this.error$.next(error);
                    this.isLoading$.next(false);
                });
        }
    }

    resetPassword() {
        this.router.navigateByUrl('forgot-password');
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }
}
